import { AnyAction } from 'redux'
import { logger } from 'helpers/logger'
import { makeSerializable } from './makeSerializable'

export type SendMessageProps = {
  action: AnyAction
  windowElement?: Window | null
  whitelist?: AnyAction[]
}

export const sendMessage = ({
  action,
  windowElement,
  whitelist,
}: SendMessageProps) => {
  const windowElementLocal = windowElement ?? window.parent ?? window

  if (!windowElementLocal) return

  try {
    const { type: actionType } = action

    const isWhitelisted = whitelist
      ? whitelist.some(({ type }) => type === actionType || type === '*')
      : true

    if (!isWhitelisted) return

    const serializableAction = makeSerializable(action)
    windowElementLocal.postMessage(serializableAction, '*')
  } catch (error) {
    logger.error('Failed to process or send message:', error)
  }
}
